<template>
  <div style="background-color: #fff">
    <div class="p">
      <div
        v-for="(item, index) in trace_entrances"
        :key="index"
        @click="hClick(item)"
        class="mb"
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div style="display: flex; align-items: center">
          <div class="logo">
            <img :src="item.icon_url" alt="" />
          </div>
          <div class="ml">{{ item.entrance_name }}</div>
        </div>
        <div><img src="@/assets/images/l.png" alt="" class="l" /></div>
      </div>
    </div>

    <van-overlay :show="show">
      <div class="wrapper">
        <div class="code">
          <img :src="url" alt="" />
        </div>
        <div style="margin-top: 10px" @click="show = false">
          <img src="../assets/images/关闭按钮.png" alt="" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>
  
  <script>
import { Dialog } from "vant";
import { Toast } from "vant";

export default {
  data() {
    return {
      show: false,

      applet_rqcode: "",
      jd_url: "",
      taobao_url: "",
      tiktok_qrcode: "",
      official_website: "",
      ghz_qrcode: "",
      url: "",
      trace_entrances: [],
    };
  },
  created() {
    this.id = this.$route.query.id;
    let data = JSON.parse(window.localStorage.getItem("reData"));
    this.list = data.data;
    this.init();
    // this.microblog = data.microblog;
    // this.applet_rqcode = data.applet_rqcode;
    // this.jd_url = data.jd_url;
    // this.taobao_url = data.taobao_url;
    // this.tiktok_qrcode = data.tiktok_qrcode;
    // this.official_website = data.official_website;
    // this.ghz_qrcode = data.ghz_qrcode;
  },
  methods: {
    init() {
      let list = this.list.filter((item) => item.id == this.id);
      this.trace_entrances = list[0].trace_entrances;
      console.log(this.trace_entrances);
    },
    hClick(e) {
      if (e.entrance_type == 3) {
        if (!e.popup_content) return Toast("暂未设置");
        Dialog.confirm({
          title: e.entrance_name,
          message: e.popup_content,
          confirmButtonText: "复制",
        })
          .then(() => {
            this.$copyText(e.popup_content).then(
              (e) => {
                console.log(e);
                Toast("复制成功");
              },
              (err) => {
                console.log(err);

                Toast("复制失败");
              }
            );
          })
          .catch(() => {
            // on cancel
          });
      } else if (e.entrance_type == 2) {
        if (!e.jump_url) return Toast("暂未设置");
        location.href = e.jump_url;
      } else if (e.entrance_type == 4) {
        if (!e.qrcode_url) return Toast("暂未设置");
        this.url = e.qrcode_url;
        this.show = true;
      } else if (e.entrance_type == 1) {
        this.$router.push(`/wangdian?id=${e.id}`);
      }
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.wrapper {
  width: 574px;
  height: 610px;

  border-radius: 20px 20px 20px 20px;
  margin: 50% auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  .code {
    img {
      width: 414px;
      height: 414px;
    }
  }
  img {
    width: 52px;
    height: 52px;
  }
}
.p {
  padding: 38px;
}
.ml {
  margin-left: 15px;
}
.mb {
  margin-bottom: 56px;
}
.logo {
  width: 78px;
  height: 78px;
  img {
    width: 100%;
    height: 100%;
  }
}
.text {
  font-size: 32px;
  font-weight: bold;
}
.l {
  width: 11px;
  height: 21px;
}
</style>